import  { createContext, useContext } from 'react';

// Creating a Context
export const NotificationContext = createContext({
  refetchNotifications: () => {},
});

export const useNotificationContext = () => useContext(NotificationContext);
